/**
 * Classe des pays
 */
export class GeoPays {
    constructor(row) {
        var _a, _b, _c, _d;
        if (row) {
            this.idPays = (_a = row.idPays) !== null && _a !== void 0 ? _a : null;
            this.code = (_b = row.code) !== null && _b !== void 0 ? _b : null;
            this.libelle = (_c = row.libelle) !== null && _c !== void 0 ? _c : null;
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : null;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2VvUGF5cy5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkdlb1BheXMuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sT0FBTztJQXFCbkIsWUFBbUIsR0FBc0I7O1FBQ3hDLElBQUksR0FBRyxFQUFFO1lBQ1IsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFBLEdBQUcsQ0FBQyxNQUFNLG1DQUFJLElBQUksQ0FBQztZQUNqQyxJQUFJLENBQUMsSUFBSSxHQUFHLE1BQUEsR0FBRyxDQUFDLElBQUksbUNBQUksSUFBSSxDQUFDO1lBQzdCLElBQUksQ0FBQyxPQUFPLEdBQUcsTUFBQSxHQUFHLENBQUMsT0FBTyxtQ0FBSSxJQUFJLENBQUM7WUFDbkMsSUFBSSxDQUFDLEtBQUssR0FBRyxNQUFBLEdBQUcsQ0FBQyxLQUFLLG1DQUFJLElBQUksQ0FBQztTQUMvQjtJQUNGLENBQUM7Q0FDRCJ9